export const TOKEN_REFRESH = '/api/authentication/v1/token/refresh/';
export const WORKSPACE_TOKEN_REFRESH = 'api/authentication/v1/workspaces/';
